import { render, staticRenderFns } from "./aset.vue?vue&type=template&id=10a71234"
import script from "./aset.vue?vue&type=script&lang=js"
export * from "./aset.vue?vue&type=script&lang=js"
import style0 from "./aset.vue?vue&type=style&index=0&id=10a71234&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports